"use strict";
/* globals module */
/**
 * @module notificationsRegistrationsClient
 * @description  Notifications Registrations Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsClient` uses `notificationsRegistrationsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var _1 = require("./");
var NotificationsRegistrationsClient = /** @class */ (function () {
    function NotificationsRegistrationsClient(notificationsRegistrationsRoute, notificationsRegistrationsAnonymousClient, notificationsRegistrationsUsersClient) {
        this.notificationsRegistrationsRoute = notificationsRegistrationsRoute;
        this.notificationsRegistrationsAnonymousClient = notificationsRegistrationsAnonymousClient;
        this.notificationsRegistrationsUsersClient = notificationsRegistrationsUsersClient;
    }
    Object.defineProperty(NotificationsRegistrationsClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsClient.prototype, "anonymous", {
        get: function () {
            return this.notificationsRegistrationsAnonymousClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsClient.prototype, "users", {
        get: function () {
            return this.notificationsRegistrationsUsersClient;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c;
    NotificationsRegistrationsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsRoute !== "undefined" && _1.NotificationsRegistrationsRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsAnonymousClient !== "undefined" && _1.NotificationsRegistrationsAnonymousClient) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsRegistrationsUsersClient !== "undefined" && _1.NotificationsRegistrationsUsersClient) === "function" ? _c : Object])
    ], NotificationsRegistrationsClient);
    return NotificationsRegistrationsClient;
}());
exports.NotificationsRegistrationsClient = NotificationsRegistrationsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
